import React from "react";
import PageHeader from "../../components/organisms/PageHeader";
import List from "../../components/organisms/List";

const MuseumPermanent = () => {
    const row = [{
        "boarIdx": 1,
        "postId": 1,
        "boardId": 10,
        "subject": "강아지숲 박물관",
        "thumbnail": "/NS/UploadFile/board/thumb/thumb_64_1675751292.jpg",
        "link":"/map/museum"
    }];
    const navList = [
        {
            name: "상설 전시",
            link: "/program/museum/permanent"
        },
        {
            name: "특별 전시",
            link: "/program/museum/special"
        },
        {
            name: "지난 전시",
            link: "/program/museum/past"
        },
    ];

    return (
        <>
            <PageHeader
                bTitle="프로그램"
                detail="상설 전시"
                desc="강아지숲 상설 전시를 안내해 드립니다."
                list={navList}
                top={true}
            />

            <List
                row={row}
                columns={3}
                category={"상설 전시"}
                pagination={false}
            />
        </>
    );
};

export default MuseumPermanent;
